import React from 'react'
import { withLDProvider } from 'launchdarkly-react-client-sdk'

// Styles
import 'bootstrap/dist/css/bootstrap.min.css'

// Routing
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PlayerDashboard from './Pages/PlayerDashboard/PlayerDashboard';
import GuideDashboard from './Pages/GuideDashboard/GuideDashboard';
import PlayerJoin from './Pages/PlayerJoin/PlayerJoin';
import GuideGameOverview from './Pages/GuideGameOverview/GuideGameOverview';
import ATCDashboard from './Pages/ATCDashboard';
import Login from './Pages/Login';
import Profile from './Pages/ATCDashboard/Profile';
import UserPrivate from './auth/UserPrivate';
import XolaSettings from './Pages/ATCDashboard/Profile/XolaSettings';
import ClientTestPage from './Pages/ClientTestPage/ClientTestPage';
import ExperienceListView from './Pages/Admin/ExperienceListView';
import ExperienceDetailView from './Pages/Admin/ExperienceDetailView';
import UserListView from './Pages/Admin/UserListView';
import UserDetailView from './Pages/Admin/UserDetailView';
import UserCreateView from './Pages/Admin/UserCreateView';
import { TEG_APP } from 'lib/constants'
import CarnivalTest from './Pages/CarnivalTest'


const App = () => {

  return (
    <div>
      <Router>
       <Switch>
         <Route exact path="/host/:game" component={GuideDashboard}/>
         <Route exact path="/guide" component={GuideGameOverview}/>
         <Route exact path="/" component={PlayerJoin}/>
         <Route exact path="/play/:game" component={PlayerDashboard}/>
         <Route exact path="/carnival-test/:game" component={CarnivalTest} />
         <UserPrivate exact path="/atc" component={ATCDashboard}/>
         <UserPrivate exact path="/settings" component={Profile}/>
         <UserPrivate exact path="/settings/password" component={Profile}/>
         <UserPrivate exact path="/settings/xola" component={XolaSettings}/>
         <Route exact path="/login" component={Login}/>
         <Route exact path="/test" component={ClientTestPage}/>
         <UserPrivate exact path="/admin/experiences/" component={ExperienceListView}/>
         <UserPrivate exact path="/admin/experiences/:id" component={ExperienceDetailView}/>
         <UserPrivate exact path="/admin/users/" component={UserListView}/>
         <UserPrivate exact path="/admin/users/create" component={UserCreateView}/>
         <UserPrivate exact path="/admin/users/:id" component={UserDetailView}/>
       </Switch>
      </Router>
    </div>
  )
  
}

export default withLDProvider({
  clientSideID: TEG_APP.LAUNCH_DARKLY_CLIENT_SIDE_ID,
  user: { key: "remote-adventures" }
})(App);
